import React from 'react';
import { ProductListCard } from './Component';
import Text from '../common/ui/Text';
import { Image, ImageContainer } from '../common/ui/Image'
import CustomLink from '../common/ui/CustomLink';

const ProductList = ({ data, ...rest }) => {
  return (  
    Array.isArray(data) && data.length !== 0 && data.map((x, i) => (
      <CustomLink to={x.link ? `${x.link}` : ""} key={i}>
        <ProductListCard 
          {...rest.listcard} 
          key={i}
        >
          <ImageContainer 
            width="unset" 
            height="35px"
            sHeight={x.sHeight}
            sWidth={x.sWidth}
            margin="0 auto"
          >
            <Image 
              src={x.src} 
              width={x.width}
            />
          </ImageContainer>
          <Text 
            {...rest.textstyle}
          >
            {x.productName}
          </Text>
        </ProductListCard>
      </CustomLink>
    )) 
  )
}

export default ProductList;